module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAAHnix0jAAAAAXNSR0IArs4c6QAAAH5JREFUOBFj1Mj/3/qfgaGKAQiYQAQMoHAY1fP/A1UhKUGRhunBT8MNgSljZGT4BWOj0BSqZET2FIrBSBycliOpgTMH0ERGjYL/P4GBzwZ3DBYGIwNDGxkxgsUksoRGphtBieIzMFfwkBVmaJqAMfgFTWgkcEfDkPJYpnoYAgAiWDuR0teh6gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/shortActive/shortActiveIcon.png
// module id = 925
// module chunks = 1